<template>
  <li class="profile-nav onhover-dropdown p-0 mr-0">
    <div class="media profile-media">
      <img class="b-r-10" src="../../assets/images/dashboard/profile.jpg" alt="" />
      <div class="media-body">
        <span class="cut-text" style="max-width: 150px;min-width: 75px;">{{ user.displayName }}</span>
        <p class="mb-0 text-white">
          {{ getMemberGrade() }} <i class="middle fa fa-angle-down"></i>
        </p>
      </div>
    </div>
    <ul class="profile-dropdown onhover-show-div">
      <!-- <li>
        <router-link to="/profile/settings">
          <feather type="settings"></feather><span>{{ $t("lbl_EMPBE_Setting") }}</span>
        </router-link>
      </li> -->
      <li v-if="false">
        <router-link to="/orderHistory" class="d-flex" v-bind:t_label="'EMPBE_Header_OrderHistory'">
          <feather type="shopping-bag" class="mr-2"></feather><span>{{ $t("lbl_EMPBE_OrderHistory") }}</span>
        </router-link>
      </li>
      <li>
        <a @click="logout" v-bind:t_label="'EMPBE_Header_Logout'">
          <feather type="log-in"></feather><span>{{ $t("lbl_EMPBE_Logout") }}</span>
        </a>
      </li>
    </ul>
  </li>
</template>

<script>

export default {
  name: 'Profile',
  computed: {
    user() {
      return this.$store.state.authentication.user
    }
  },
  methods: {
    logout: function () {
      this.$store.dispatch('authentication/logout');
    },
    getMemberGrade() {
      var currentLangId = localStorage.getItem('currentLangId');
      if(this.user.userType == "ADMIN"){
        return "ADMIN"
      }
      return currentLangId == "950" ? this.user.memberGradeTc : currentLangId == "936" ? this.user.memberGradeSc : currentLangId == "1252" ? this.user.memberGradeEn : ""
    }
  },
};
</script>
